var map = {
	"./Hero_Pixelmon.mp4": 832,
	"./Hero_Serum.mp4": 9848,
	"./Hero_Trainer.mp4": 4424,
	"./Metamask.png": 4684,
	"./TrustWallet.png": 7376,
	"./all-nft.jpg": 7748,
	"./ancrypto.webp": 9392,
	"./android.webp": 9968,
	"./apple.webp": 5792,
	"./arrow.svg": 9964,
	"./background-3.mp4": 2420,
	"./banner-img-1.jpg": 5220,
	"./banner-img-2.jpg": 6927,
	"./banner-img-3.jpg": 2564,
	"./banner-img-4.jpg": 8079,
	"./bath.svg": 3672,
	"./bed.svg": 8688,
	"./bg-info12.mp4": 1812,
	"./blog-cosmos.jpg": 7924,
	"./blog-game.jpg": 1308,
	"./blog-img-1.jpg": 9172,
	"./blog-img-2.jpg": 284,
	"./blog-img-3.jpg": 7488,
	"./blog-metaverse.jpg": 7544,
	"./blog-nft.jpg": 3728,
	"./chart.svg": 2524,
	"./coin.svg": 3692,
	"./comic1.jpg": 4584,
	"./comic2.jpg": 3996,
	"./cosmos-2.gif": 3676,
	"./cosmos-game.gif": 5320,
	"./cosmos.webp": 7084,
	"./cryptocurrency_8309742.png": 5036,
	"./cta-bg.webp": 9216,
	"./cta-home.webp": 6696,
	"./cursor.svg": 9804,
	"./digital-art-monkey.jpg": 7828,
	"./domain-name.jpg": 8480,
	"./events.jpg": 2152,
	"./explore1.jpg": 2364,
	"./explore2.png": 7596,
	"./explore3.webp": 9592,
	"./fastpay.png": 3144,
	"./featured1.webp": 5088,
	"./featured2.webp": 3208,
	"./featured3.webp": 5208,
	"./featured4.webp": 5799,
	"./future-rea.jpg": 3588,
	"./futuristic-sp.jpg": 520,
	"./game-1.mp4": 5228,
	"./game-2.mp4": 6068,
	"./game-3.mp4": 2876,
	"./game-bg.jpg": 8680,
	"./game-bg.png": 7704,
	"./game-controller.png": 1772,
	"./game-img-1.jpg": 4717,
	"./game-img-2.jpg": 2332,
	"./game-img-3.jpg": 4116,
	"./game-img-4.jpg": 4432,
	"./game-img-5.jpg": 9332,
	"./game-slider-1.png": 6132,
	"./game-slider-2.png": 9276,
	"./game-slider-3.png": 976,
	"./game-slider-4.png": 7504,
	"./gaming-1.svg": 2096,
	"./gaming-2.svg": 5140,
	"./gaming-3.svg": 341,
	"./gaming-4.svg": 2300,
	"./hero.mp4": 8868,
	"./landing-bg.png": 4696,
	"./logo.png": 8540,
	"./meta-bg.jpg": 4740,
	"./meta.jpg": 4388,
	"./meta1.jpg": 6060,
	"./meta2.jpg": 2981,
	"./meta3.jpg": 9708,
	"./meta4.jpg": 9540,
	"./meta5.jpg": 5764,
	"./meta6.jpg": 0,
	"./meta7.jpg": 309,
	"./meta8.jpg": 4428,
	"./meta9.jpg": 4780,
	"./metaverse-1.jpg": 4460,
	"./metaverse-2.jpg": 2620,
	"./metaverse-3.mp4": 4632,
	"./metaverse-gaming.png": 3624,
	"./metaverse.png": 6684,
	"./music-img.jpg": 5284,
	"./new-chart.svg": 4288,
	"./nft-img-1.jpg": 6836,
	"./nft-img-2.jpg": 1388,
	"./nft-img-3.jpg": 5184,
	"./nft-img-4.jpg": 340,
	"./nft-img-5.jpg": 6496,
	"./nft-img-6.jpg": 7608,
	"./nft-img-7.jpg": 7868,
	"./nft-img-8.jpg": 1504,
	"./nft-img/autherium.png": 4236,
	"./nft-img/binance.png": 3380,
	"./nft-img/coinbase.png": 7687,
	"./nft-img/formatic.png": 6064,
	"./nft-img/metamax.png": 9088,
	"./nft-img/nft-1.jpg": 3220,
	"./nft-img/nft-2.gif": 7780,
	"./nft-img/nft-3.gif": 2878,
	"./nft-img/nft-4.jpg": 2292,
	"./nft-img/nft-top-2-cat.png": 1148,
	"./nft-img/nft-top-img.png": 1404,
	"./nft-img/portise.png": 6912,
	"./nord.svg": 3668,
	"./nordek.png": 8592,
	"./norder-k.png": 7484,
	"./nordex-new.png": 7696,
	"./paperbg.jpg": 8788,
	"./partner1.png": 1020,
	"./partner2.png": 1360,
	"./partner3.png": 1396,
	"./partner4.png": 3340,
	"./partner5.png": 2092,
	"./partner6.jpg": 5384,
	"./partner7.png": 6516,
	"./partner8.png": 5380,
	"./real-estate-1.jpg": 2192,
	"./real-estate-2.jpg": 2143,
	"./real-estate-3.jpg": 3564,
	"./real-estate-4.jpg": 2516,
	"./real-estate-5.jpg": 2976,
	"./real-estate.mp4": 140,
	"./real1.jpg": 1340,
	"./real2.jpg": 7184,
	"./real3.jpg": 5600,
	"./real4.jpg": 6559,
	"./real5.jpg": 7360,
	"./room.svg": 9764,
	"./seller-img-1.jpg": 6444,
	"./seller-img-2.jpg": 6356,
	"./seller-img-3.jpg": 6080,
	"./seller-img-4.jpg": 7028,
	"./seller-img-5.jpg": 9184,
	"./seller-img-6.jpg": 9164,
	"./seller-img-7.jpg": 1768,
	"./seller-img-8.jpg": 2736,
	"./slider-1.88dcd828.jpg": 5352,
	"./slider-1.jpg": 6948,
	"./slider-2.jpg": 3832,
	"./slider-3.jpg": 6788,
	"./slider-4.jpg": 9612,
	"./sports.jpg": 3072,
	"./star-nest.png": 5680,
	"./starnest.svg": 3628,
	"./testimonial1.webp": 7136,
	"./testimonial2.png": 6744,
	"./testimonial3.png": 2868,
	"./testimonial4.png": 5504,
	"./testimonial5.webp": 9680,
	"./top-seller-img-1.jpg": 756,
	"./utilities.jpg": 3884,
	"./virtual-real.png": 1472,
	"./virtual.jpg": 2584,
	"./vr-ar.jpg": 5604,
	"./wallet-img-1.jpg": 7756,
	"./wallet-img-2.jpg": 9496,
	"./wallet-img-3.jpg": 4364,
	"./wallet-img-4.jpg": 3032,
	"./wallet-img-5.jpg": 7564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 748;